import React from "react";
import { AiOutlineMail } from "react-icons/ai";

import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <>
      <div className="bg-darkGray text-white">
        <div className="container max-w-screen-xl mx-auto px-4 py-8 md:py-16">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
            {/* Contacts Section */}
            <div className="text-center md:text-left">
              <h1 className="text-xl md:text-2xl font-heading font-medium mb-4">
                Contacts
              </h1>
              <h2 className="text-sm md:text-lg font-body mb-4 leading-relaxed">
                191 Coldharbour Ln, London, United Kingdom, SE5 9PA
              </h2>
              <div className="flex items-center justify-center md:justify-start gap-2 text-sm md:text-base font-body">
                <AiOutlineMail className="text-lg" />
                <span>help@zamchainadvanceinvestment.com</span>
              </div>
            </div>

            {/* Links Section */}
            <div className="text-center md:text-left">
              <h1 className="text-xl md:text-2xl font-heading font-medium mb-4">
                Links
              </h1>
              <div className="space-y-3">
                <a
                  className="block text-sm md:text-lg font-body hover:text-primary transition duration-300"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.coinbase.com"
                >
                  Coinbase.com
                </a>
                <a
                  className="block text-sm md:text-lg font-body hover:text-primary transition duration-300"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.coinmama.com/"
                >
                  Coinmama.com
                </a>
              </div>
            </div>

            {/* Investment Disclosure Section */}
            <div className="text-center md:text-left">
              <h1 className="text-xl md:text-2xl font-heading font-medium mb-4">
                Investment Disclosure
              </h1>
              <p className="font-body text-xs md:text-sm leading-relaxed text-gray-300">
                When you invest with Zam-chain Advanced investment, you are more
                than a number; you are a partner. As a partner with us, you can
                access opportunities usually reserved only for the largest
                institutional investors. You can access a team driven only by
                excellence and results. You can access real estate investment
                opportunities designed with you in mind.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright Section */}
      <div className="bg-darkGray text-white border-t border-gray-700">
        <div className="container max-w-screen-xl mx-auto px-4 py-4">
          <p className="text-sm md:text-base text-center text-gray-400">
            Zam-chain Advanced Investment &copy; 2022
          </p>
        </div>
      </div>
    </>
  );
};

export default Footer;
